// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__1ZLzD","open":"Dropdown_open__djPQ0","bottom":"Dropdown_bottom__nMXMs","top":"Dropdown_top__omxon"};